export var DTParsedThemeSetPriority;
(function (DTParsedThemeSetPriority) {
    DTParsedThemeSetPriority["source"] = "source";
    DTParsedThemeSetPriority["enabled"] = "enabled";
    DTParsedThemeSetPriority["disabled"] = "disabled";
})(DTParsedThemeSetPriority || (DTParsedThemeSetPriority = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Tool implementation
/** Design Tokens Plugin Manipulation Tool */
export class DTJSONParser {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(logger) {
        this.themeBuffer = new Array();
        this.logger = logger;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Data Parser
    processPluginDataRepresentation(definition) {
        const sets = this.processSets(definition);
        const nodes = this.parseNode([], definition, sets);
        const themes = this.processThemes(definition, sets);
        const setArray = Array.from(sets.values());
        this.logger.log(`----- Loaded token data:`);
        this.logger.log(`Nodes: ${nodes.length}`);
        this.logger.log(`Sets: ${setArray.length}, ${setArray.map((s) => `\n | ${s.name}: ${s.contains.length} nodes`)}`);
        this.logger.log(
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `Themes: ${themes.length}, ${themes.map((t) => `\n | ${t.name}: ${t.selectedTokenSets.filter((s) => s.priority !== DTParsedThemeSetPriority.disabled).length} sets`)}`);
        return {
            nodes,
            sets: Array.from(sets.values()),
            themes,
        };
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Theme Parser
    processThemes(definition, tokenSets) {
        const themes = new Array();
        let order = [];
        // Find metadata
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const metadata = definition.$metadata;
        if (metadata) {
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const setOrder = metadata.tokenSetOrder;
            if (setOrder) {
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                order = setOrder;
            }
        }
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const themeDefinitions = definition.$themes; // Parse each theme separately
        if (themeDefinitions) {
            for (const themeObject of themeDefinitions) {
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const { name } = themeObject;
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const { id } = themeObject;
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const { selectedTokenSets } = themeObject;
                if (!name || !id || !selectedTokenSets) {
                    // Skip execution of this theme as it doesn't have correct information provided
                    throw new Error("Incorrect theme data structure, missing one of required attributes [name, id, selectedTokenSets]");
                }
                // Process token sets
                const pairedSets = new Array();
                for (const [tokenSetName, unknownPriority] of Object.entries(
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                selectedTokenSets)) {
                    const setName = tokenSetName;
                    const setPriority = unknownPriority;
                    const fetchedSet = tokenSets.get(setName);
                    const pair = {
                        priority: setPriority,
                        // @ts-expect-error TS(2322): Type 'DTParsedTokenSet | undefined' is not assigna... Remove this comment to see the full error message
                        set: fetchedSet,
                    };
                    pairedSets.push({ name: setName, pair });
                }
                // Respect $metadata.json -> tokenSetOrder
                if (order.length) {
                    // We could have process tokens in reverse orders here, and do not replace tokens at all:
                    // i.e. trying to resolve higher priority tokens first and add them in DTTokenReferenceResolver
                    // but lower priority tokens still could be resolved earlier, so reverse sort order would not help.
                    pairedSets.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
                }
                const theme = {
                    // TODO:fix-sdk-eslint
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return
                    selectedTokenSets: pairedSets.map((o) => o.pair),
                    // TODO:fix-sdk-eslint
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    name,
                    // TODO:fix-sdk-eslint
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    id,
                };
                themes.push(theme);
            }
        }
        return themes;
    }
    processSets(definition) {
        const sets = new Map();
        // Parse top level objects as sets, unless they contain $
        // Value is ignored, as that is parsed separately
        for (const [setName] of Object.entries(definition)) {
            if (!setName.startsWith("$")) {
                const set = {
                    contains: [],
                    name: setName,
                    id: setName,
                };
                sets.set(setName, set);
            }
        }
        return sets;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Node Parser
    parseNode(path, objects, sets) {
        var _a, _b, _c, _d;
        let result = [];
        for (const [name, value] of Object.entries(objects)) {
            if (typeof value === "object") {
                if (
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, no-prototype-builtins
                (value.hasOwnProperty("value") && value.hasOwnProperty("type")) || // TODO:fix-sdk-eslint
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, no-prototype-builtins
                    (value.hasOwnProperty("$value") && value.hasOwnProperty("$type"))) {
                    // Treat as value
                    const rootKey = path[0];
                    if (!rootKey) {
                        throw new Error("Node references unknown root key");
                    }
                    let entity = {
                        rootKey,
                        name,
                        path,
                        // TODO:fix-sdk-eslint
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                        type: (_a = value.type) !== null && _a !== void 0 ? _a : value.$type,
                        // TODO:fix-sdk-eslint
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                        value: (_b = value.value) !== null && _b !== void 0 ? _b : value.$value,
                        // TODO:fix-sdk-eslint
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                        description: (_d = (_c = value.description) !== null && _c !== void 0 ? _c : value.$description) !== null && _d !== void 0 ? _d : null,
                    };
                    const set = sets.get(entity.rootKey);
                    if (!set) {
                        throw new Error("Node references unknown set");
                    }
                    entity = this.modifyEntityForParse(entity);
                    set.contains.push(entity);
                    result.push(entity);
                }
                else if (name.startsWith("$")) {
                    // Skipping keys internal to design token plugin because we are currently not using them
                }
                else {
                    // Treat as leaf
                    // TODO:fix-sdk-eslint
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    result = result.concat(this.parseNode(path.concat(name), value, sets));
                }
            }
            else {
                throw new Error("Unable to parse, unsupported structure in token node leaf");
            }
        }
        return result;
    }
    modifyEntityForParse(entity) {
        // Modify some entities to be parsed correctly by directly manipulating their values
        // Workaround for differentiating between color and gradient - as they are both defined as color in TS
        if (entity.type === "color") {
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            if (entity.value.includes("linear-gradient")) {
                entity.type = "gradient";
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                entity.value = entity.value.replace("linear-gradient", "");
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            }
            else if (entity.value.includes("radial-gradient")) {
                entity.type = "gradient";
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                entity.value = entity.value.replace("radial-gradient", "");
            }
        }
        // Workaround for opacity not being defined as percentage
        if (entity.type === "opacity") {
            try {
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unused-vars
                const entityValue = entity.value;
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                const opacity = parseFloat(entity.value);
                const isUnitless = !Number.isNaN(Number(entity.value));
                if (isUnitless && (opacity >= 0 || opacity <= 1)) {
                    entity.value = `${opacity * 100}%`;
                }
            }
            catch (e) {
                // Do nothing here
            }
        }
        return entity;
    }
}
